/**
 * Idempotency keys.
 *
 * A key is generated once, when the user acts, and reused for every retry of
 * that same action — including a retry that happens days later, when a queued
 * offline attendance event finally reaches the server. Generating a fresh key
 * on retry would defeat the entire mechanism: the server would see a new
 * request and apply it again.
 *
 * That is why this returns a value the caller is expected to *store* alongside
 * the pending action, rather than something computed at send time.
 */

export function newIdempotencyKey(): string {
  const crypto = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (crypto?.randomUUID) return crypto.randomUUID();

  // Hermes without the polyfill. Time plus randomness is enough here: the key
  // only has to be unique among one person's in-flight actions.
  const random = Math.floor(Math.random() * 1e12).toString(36);
  return `idem-${Date.now().toString(36)}-${random}`;
}
